import { Navigate, redirect, useParams, type RouteDefinition } from "@solidjs/router";

export const route = {
  preload: ({ params }) => {
    return redirect(`/video/${params.id}`);
  },
} satisfies RouteDefinition;

export default function VideosRedirectPage() {
  const params = useParams();
  return <Navigate href={`/video/${params.id}`} />;
}
